(function () {
  if (window.CernirProductOptions) {
    window.CernirProductOptions.init(document);
    return;
  }

  var activeGuideTrigger = null;
  var guideBackgroundState = [];
  var guideBodyOverflow = null;
  var buckleTypePreferences = {};

  /* Mirror the visual .is-selected state for screen readers. */
  function syncPressedState(scope) {
    if (!scope) return;
    scope.querySelectorAll('.cvp-pill, .cvp-swatch, .cernir-buckle__row').forEach(function (button) {
      button.setAttribute('aria-pressed', button.classList.contains('is-selected') ? 'true' : 'false');
    });
  }

  function getGuideFocusableElements(modal) {
    if (!modal) return [];

    return Array.from(modal.querySelectorAll('a[href], area[href], button, input, select, textarea, [tabindex]')).filter(function (element) {
      if (element.disabled || element.getAttribute('aria-hidden') === 'true' || element.getAttribute('tabindex') === '-1') return false;
      return element.getClientRects().length > 0;
    });
  }

  function lockGuideBackground(modal) {
    guideBackgroundState = [];
    guideBodyOverflow = document.body.style.overflow;

    Array.from(document.body.children).forEach(function (element) {
      if (element === modal || element.contains(modal)) return;
      guideBackgroundState.push({ element: element, inert: element.inert });
      element.inert = true;
    });

    document.body.style.overflow = 'hidden';
    document.documentElement.classList.add('cernir-guide-open');
  }

  function unlockGuideBackground() {
    guideBackgroundState.forEach(function (state) {
      if (state.element.isConnected) state.element.inert = state.inert;
    });
    guideBackgroundState = [];

    if (guideBodyOverflow !== null) document.body.style.overflow = guideBodyOverflow;
    guideBodyOverflow = null;
    document.documentElement.classList.remove('cernir-guide-open');
  }

  function eachMatch(scope, selector, callback) {
    if (!scope) return;
    if (scope.matches && scope.matches(selector)) callback(scope);
    if (scope.querySelectorAll) scope.querySelectorAll(selector).forEach(callback);
  }

  function closeGuideModal(modal, restoreFocus) {
    if (!modal || !modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.cvp-modal.is-open')) unlockGuideBackground();
    if (activeGuideTrigger) {
      activeGuideTrigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus && activeGuideTrigger.isConnected) activeGuideTrigger.focus();
      activeGuideTrigger = null;
    }
  }

  function closeHelp(button, restoreFocus) {
    var help = document.getElementById(button.getAttribute('aria-controls'));
    button.setAttribute('aria-expanded', 'false');
    if (help) help.hidden = true;
    if (restoreFocus) button.focus();
  }

  function closeAllHelp(selector, exceptButton) {
    document.querySelectorAll(selector + '[aria-expanded="true"]').forEach(function (button) {
      if (button !== exceptButton) closeHelp(button, false);
    });
  }

  function syncPersonalizationCount(input) {
    if (!input || !input.matches('.cernir-personalization input[maxlength]')) return;
    var personalization = input.closest('.cernir-personalization');
    var count = personalization ? personalization.querySelector('[data-personalization-count]') : null;
    if (!count) return;
    var max = Number(input.getAttribute('maxlength')) || 0;
    count.textContent = input.value.length + '/' + max;
  }

  function initVariantPicker(wrapper) {
    if (wrapper.dataset.cvpInitialized === 'true') return;
    wrapper.dataset.cvpInitialized = 'true';
    var customSelectionValue = '__custom__';

  /* Display-only formatters. Option values remain the untouched Shopify values. */
  function formatLugWidth(rawValue) {
    var match = String(rawValue || '').match(/^\s*(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)\s*(?:mm)?\s*$/i);
    return match ? match[1] + ' → ' + match[2] + ' mm' : rawValue;
  }

  function formatStrapSize(rawValue) {
    var match = String(rawValue || '').match(/^\s*([SML])\s*\(\s*(\d+)\s*\/\s*(\d+)\s*(?:mm)?\s*\)\s*$/i);
    if (!match) return rawValue;
    var names = { S: 'Short', M: 'Standard', L: 'Long' };
    var code = match[1].toUpperCase();
    return code + ' · ' + names[code] + ' · ' + match[2] + '/' + match[3] + ' mm';
  }

  wrapper.querySelectorAll('.cvp-option[data-option-role="lug"] option[data-raw-value], .cvp-option[data-option-role="length"] option[data-raw-value]').forEach(function (option) {
    var block = option.closest('.cvp-option');
    var rawValue = option.dataset.rawValue;
    var displayValue = block.dataset.optionRole === 'lug' ? formatLugWidth(rawValue) : formatStrapSize(rawValue);
    option.textContent = displayValue + (option.disabled ? ' — Sold out' : '');
  });

  wrapper.querySelectorAll('.cvp-dropdown').forEach(function (dropdown) {
    var customInput = dropdown.closest('.cvp-option')?.querySelector('.cvp-custom-input__field');
    var customWrap = dropdown.closest('.cvp-option')?.querySelector('.cvp-custom-input');
    if (!customInput || !customWrap) return;
    var customSelected = dropdown.value === customSelectionValue;
    customWrap.style.display = customSelected ? 'block' : 'none';
    customInput.disabled = !customSelected;
    customInput.setCustomValidity(customSelected && !customInput.value.trim() ? 'Please enter a custom value.' : '');
  });

  /* Instance-scoped guide dialogs also work when this picker is rendered in quick buy. */
  var ownerId = wrapper.dataset.cvpOwner;
  var instanceModals = Array.from(document.querySelectorAll('.cvp-modal[data-cvp-owner]')).filter(function (modal) {
    return modal.dataset.cvpOwner === ownerId && modal.dataset.cvpModalMounted !== 'true';
  });
  instanceModals.forEach(function (modal) {
    document.querySelectorAll('.cvp-modal[data-cvp-owner]').forEach(function (candidate) {
      if (candidate !== modal && candidate.dataset.cvpOwner === ownerId && candidate.id === modal.id) candidate.remove();
    });
    modal.dataset.cvpModalMounted = 'true';
    document.body.appendChild(modal);
  });

  if (wrapper.dataset.cvpBound === 'true') return;
  wrapper.dataset.cvpBound = 'true';
  var formId = wrapper.dataset.productFormId;
  var instanceAbortController = new AbortController();
  var validationAbortController = null;
  var purchaseObserver = null;
  var destroyed = false;

  /* Tất cả variants dưới dạng JSON (do Liquid render) */
  var variantsJson = wrapper.querySelector('[data-cvp-variants]');
  if (!variantsJson) return;

  var allVariants;
  try {
    allVariants = JSON.parse(variantsJson.textContent);
  } catch (error) {
    console.error('Unable to parse product variants for the CERNIR option picker.', error);
    return;
  }

  /* A measurement option may hold a real "Custom" value (hidden from the dropdown in Liquid).
     When it exists, a typed custom size buys that variant instead of the first standard size. */
  var customValuePositions = {};
  allVariants.forEach(function (variant) {
    [1, 2, 3].forEach(function (pos) {
      if (isReservedCustomValue(variant['option' + pos])) customValuePositions[pos] = true;
    });
  });

  function isReservedCustomValue(value) {
    return String(value || '').trim().toLowerCase() === 'custom';
  }

  function variantMatchesSelection(variant, pos) {
    var value = variant['option' + pos];
    if (selections[pos] === customSelectionValue) return !customValuePositions[pos] || isReservedCustomValue(value);
    return value === selections[pos];
  }

  var selectedVariant = allVariants.find(function (variant) {
    return String(variant.id) === wrapper.dataset.initialVariantId;
  }) || null;
  var committedVariant = selectedVariant;
  var renderPending = false;
  var renderRequestId = 0;
  var renderAbortController = null;
  var committedControlState = null;
  var purchaseState = 'incomplete';
  var paymentLockOwner = {};

  function destroy() {
    if (destroyed) return;
    destroyed = true;
    renderRequestId += 1;
    if (renderAbortController) renderAbortController.abort();
    instanceAbortController.abort();
    if (purchaseObserver) purchaseObserver.disconnect();

    var productForm = document.getElementById(formId);
    if (productForm) {
      productForm.querySelectorAll('.shopify-payment-button__button').forEach(function (control) {
        releasePaymentButtonLock(control);
      });
    }
    if (validationAbortController) validationAbortController.abort();
    if (productForm && productForm._cernirCvpValidationAbortController === validationAbortController) {
      delete productForm._cernirCvpValidationAbortController;
      delete productForm.dataset.cvpValidationBound;
    }
    if (productForm && productForm._cernirCvpPurchaseObserver === purchaseObserver) {
      delete productForm._cernirCvpPurchaseObserver;
    }
    if (productForm && productForm._cernirCvpInstanceDestroy === destroy) {
      delete productForm._cernirCvpInstanceDestroy;
    }
    if (productForm && productForm._cernirCartProductProvider === wrapper._cernirCvpInstance) {
      delete productForm._cernirCartProductProvider;
    }

    if (wrapper._cernirCvpInstance && wrapper._cernirCvpInstance.destroy === destroy) {
      delete wrapper._cernirCvpInstance;
    }
  }

  wrapper._cernirCvpInstance = {
    destroy: destroy,
    prepareCustomisation: prepareCustomisation,
    prepareCart: prepareCartSelection,
    applyLengthRecommendation: applyLengthRecommendation,
    closeGuide: closeInstanceGuide,
    refreshSelectedVariant: refreshSelectedVariant
  };

  function getProductForm() {
    return document.getElementById(formId);
  }

  /* Hidden <select name="id"> */
  var variantIdSelect = wrapper.querySelector('select.cvp-variant-id');
  var optionBlocks = Array.from(wrapper.querySelectorAll('.cvp-option'));
  var buckleBlock = wrapper.querySelector('[data-cernir-buckle-option]');
  var buckleRows = buckleBlock ? Array.from(buckleBlock.querySelectorAll('.cernir-buckle__row')) : [];

  /* Trạng thái lựa chọn hiện tại: { "1": "Black", "2": "S", ... } */
  var selections = {};

  /* ── Khởi tạo từ HTML đã render ────────────────────────────── */
  optionBlocks.forEach(function (block) {
    var pos = block.dataset.optionPosition;

    /* Pill / Swatch: đọc nút is-selected */
    var selectedBtn = block.dataset.optionRole === 'buckle'
      ? block.querySelector('.cernir-buckle__row[data-buckle-type="classic"].is-selected')
      : block.querySelector('.cvp-pill.is-selected, .cvp-swatch.is-selected');
    if (selectedBtn) {
      selections[pos] = selectedBtn.dataset.value;
      return;
    }
    /* Dropdown: KHÔNG đọc giá trị mặc định — để placeholder hiển thị */
  });

  function getBuckleBlock() {
    return buckleBlock;
  }

  function getActiveBuckleType() {
    return buckleBlock && buckleBlock.dataset.activeBuckleType === 'butterfly' ? 'butterfly' : 'classic';
  }

  function getSelectedBuckleRow(type) {
    var requestedType = type || getActiveBuckleType();
    return buckleRows.find(function (row) {
      return row.dataset.buckleType === requestedType && row.classList.contains('is-selected');
    }) || null;
  }

  function getFirstAvailableBuckleRow(type) {
    return buckleRows.find(function (row) {
      return row.dataset.buckleType === type && row.getAttribute('aria-disabled') !== 'true';
    }) || null;
  }

  function setBuckleError(message) {
    var buckleBlock = getBuckleBlock();
    var error = buckleBlock ? buckleBlock.querySelector('[data-buckle-error]') : null;
    if (!error) return;
    error.textContent = message || '';
    error.style.display = message ? 'block' : 'none';
  }

  function strapVariantAvailableForBuckleRow(row) {
    if (!row || !row.dataset.value) return false;
    var buckleOption = row.closest('.cvp-option');

    return allVariants.some(function (variant) {
      if (!variant.available || variant['option' + row.dataset.optionPosition] !== row.dataset.value) return false;
      return optionBlocks.every(function (block) {
        if (block === buckleOption) return true;
        var pos = block.dataset.optionPosition;
        if (!Object.prototype.hasOwnProperty.call(selections, pos)) return true;
        return variantMatchesSelection(variant, pos);
      });
    });
  }

  function updateBuckleAvailability() {
    var buckleBlock = getBuckleBlock();
    if (!buckleBlock) return;

    var strapAvailability = {};
    buckleRows.forEach(function (row) {
      var available;
      if (row.dataset.buckleType === 'butterfly') {
        available = row.dataset.addonAvailable === 'true' && Boolean(row.dataset.addonVariantId);
      } else {
        var availabilityKey = row.dataset.optionPosition + '|' + row.dataset.value;
        if (!Object.prototype.hasOwnProperty.call(strapAvailability, availabilityKey)) {
          strapAvailability[availabilityKey] = strapVariantAvailableForBuckleRow(row);
        }
        available = strapAvailability[availabilityKey];
      }
      row.classList.toggle('is-unavailable', !available);
      if (available) row.removeAttribute('aria-disabled');
      else row.setAttribute('aria-disabled', 'true');
    });

    var butterflyTab = buckleBlock.querySelector('[data-butterfly-tab]');
    var butterflyRow = getSelectedBuckleRow('butterfly');
    if (!butterflyRow || butterflyRow.getAttribute('aria-disabled') === 'true') {
      var availableButterflyRow = getFirstAvailableBuckleRow('butterfly');
      if (availableButterflyRow) {
        buckleRows.forEach(function (row) {
          if (row.dataset.buckleType === 'butterfly') row.classList.toggle('is-selected', row === availableButterflyRow);
        });
        syncPressedState(buckleBlock);
        butterflyRow = availableButterflyRow;
      }
    }
    if (butterflyTab) {
      if (butterflyTab.dataset.butterflyConfigError === 'true') {
        butterflyTab.classList.add('is-unavailable');
        butterflyTab.setAttribute('aria-disabled', 'true');
        var configurationPrice = butterflyTab.querySelector('[data-butterfly-price]');
        if (configurationPrice) configurationPrice.textContent = 'Configuration required';
        return;
      }
      var butterflyReady = Boolean(butterflyRow && butterflyRow.getAttribute('aria-disabled') !== 'true');
      butterflyTab.classList.toggle('is-unavailable', !butterflyReady);
      if (butterflyReady) butterflyTab.removeAttribute('aria-disabled');
      else butterflyTab.setAttribute('aria-disabled', 'true');
      var price = butterflyTab.querySelector('[data-butterfly-price]');
      if (price) price.textContent = butterflyRow && butterflyRow.dataset.addonPriceLabel ? butterflyRow.dataset.addonPriceLabel : 'Unavailable';
    }
  }

  if (window.Shopify && window.Shopify.designMode) {
    wrapper.querySelectorAll('[data-butterfly-config-error="true"]').forEach(function () {
      console.error('Butterfly Clasp is disabled: configure the separate Butterfly Clasp product with matching finish variants.');
    });
    wrapper.querySelectorAll('[data-buckle-type="butterfly"][data-addon-image-missing="true"]').forEach(function (row) {
      console.warn('Butterfly Clasp variant is missing a featured image:', row.dataset.addonColor);
    });
  }

  function activateBuckleType(type, showError) {
    var buckleBlock = getBuckleBlock();
    if (!buckleBlock) return false;

    updateBuckleAvailability();
    var targetRow = getSelectedBuckleRow(type) || getFirstAvailableBuckleRow(type);
    if (!targetRow || targetRow.getAttribute('aria-disabled') === 'true') {
      if (showError) setBuckleError(type === 'butterfly' ? 'No Butterfly Clasp finish is currently available.' : 'No Classic Buckle finish is available for this strap selection.');
      return false;
    }

    buckleBlock.querySelectorAll('.cernir-buckle__tab').forEach(function (item) {
      var active = item.dataset.buckleTab === type;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    buckleBlock.querySelectorAll('[data-buckle-panel]').forEach(function (panel) {
      var active = panel.dataset.bucklePanel === type;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
    var copy = buckleBlock.querySelector('[data-butterfly-copy]');
    if (copy) copy.hidden = type !== 'butterfly';
    buckleBlock.dataset.activeBuckleType = type;
    buckleTypePreferences[wrapper.dataset.productId] = type;
    buckleRows.forEach(function (row) {
      if (row.dataset.buckleType === type) row.classList.toggle('is-selected', row === targetRow);
    });
    syncPressedState(buckleBlock);
    var classicRow = getSelectedBuckleRow('classic');
    if (classicRow) selections[classicRow.dataset.optionPosition] = classicRow.dataset.value;
    setBuckleError('');
    applyVariant();
    validateSelections(false);
    return true;
  }

  /* ── Helper: tìm variant khớp tất cả lựa chọn ──────────────── */
  function syncSelectionsFromDom() {
    optionBlocks.forEach(function (block) {
      var pos = block.dataset.optionPosition;
      var selectedBtn = block.dataset.optionRole === 'buckle'
        ? getSelectedBuckleRow('classic')
        : block.querySelector('.cvp-pill.is-selected, .cvp-swatch.is-selected');
      var dropdown = block.querySelector('.cvp-dropdown');

      if (selectedBtn) {
        selections[pos] = selectedBtn.dataset.value;
      } else if (dropdown && dropdown.value && dropdown.value !== customSelectionValue) {
        selections[pos] = dropdown.value;
      } else if (dropdown && dropdown.value === customSelectionValue) {
        var customInput = block.querySelector('.cvp-custom-input__field');
        if (customInput && customInput.value.trim()) {
          selections[pos] = customSelectionValue;
        } else {
          delete selections[pos];
        }
      } else {
        delete selections[pos];
      }
    });
  }

  function findVariant() {
    syncSelectionsFromDom();

    if (optionBlocks.some(function (block) {
      return !Object.prototype.hasOwnProperty.call(selections, block.dataset.optionPosition);
    })) {
      return null;
    }

    var matchesSelections = function (v) {
      return optionBlocks.every(function (block) {
        var pos = block.dataset.optionPosition;
        return variantMatchesSelection(v, pos);
      });
    };
    var hasCustomSelection = optionBlocks.some(function (block) {
      return selections[block.dataset.optionPosition] === customSelectionValue;
    });

    if (hasCustomSelection) {
      return allVariants.find(function (variant) {
        return variant.available && matchesSelections(variant);
      }) || allVariants.find(matchesSelections) || null;
    }

    return allVariants.find(matchesSelections) || null;
  }

  function measurementParts(value) {
    return String(value || '').match(/\d+(?:\.\d+)?/g) || [];
  }

  function customMeasurementError(block, input) {
    if (!block || !input || !input.value.trim()) return 'Please enter a custom value.';
    var parts = measurementParts(input.value).map(Number);
    if (parts.length !== 2) return 'Enter two measurements, for example 20-16 mm or 115/75 mm.';

    if (block.dataset.optionRole === 'lug') {
      var lug = parts[0];
      var buckle = parts[1];
      if (!(lug > 0 && lug <= 50) || Math.abs(Math.round(lug * 10) - lug * 10) > 1e-6) return 'Enter your lug width in mm, for example 20 or 19.5.';
      if (!Number.isInteger(buckle) || buckle < 10 || buckle > 24 || buckle % 2 !== 0) return 'Buckle width must be an even number from 10 to 24 mm.';
      if (buckle > lug) return 'Buckle width cannot be wider than lug width.';
    }

    if (block.dataset.optionRole === 'length') {
      var longEnd = parts[0];
      var shortEnd = parts[1];
      if (!Number.isInteger(longEnd) || longEnd < 80 || longEnd > 160 || longEnd % 5 !== 0) return 'Long end must be 80 to 160 mm in 5 mm increments.';
      if (!Number.isInteger(shortEnd) || shortEnd < 40 || shortEnd > 100 || shortEnd % 5 !== 0) return 'Short end must be 40 to 100 mm in 5 mm increments.';
      if (longEnd < shortEnd) return 'The long end must be at least as long as the short end.';
    }

    return '';
  }

  function measurementOptionMatches(option, requestedValue) {
    var optionParts = measurementParts(option.dataset.rawValue || option.value);
    var requestedParts = measurementParts(requestedValue);
    return requestedParts.length >= 2 && optionParts.length >= 2 &&
      Number(optionParts[0]) === Number(requestedParts[0]) &&
      Number(optionParts[1]) === Number(requestedParts[1]);
  }

  function setCustomisationMeasurement(role, value) {
    var block = wrapper.querySelector('.cvp-option[data-option-role="' + role + '"]');
    var dropdown = block && block.querySelector('.cvp-dropdown');
    if (!dropdown || !value) return false;

    var exactOption = Array.from(dropdown.options).find(function (option) {
      return option.value && option.value !== customSelectionValue && !option.disabled &&
        measurementOptionMatches(option, value);
    });
    var customOption = Array.from(dropdown.options).find(function (option) {
      return option.value === customSelectionValue;
    });
    var customInput = block.querySelector('.cvp-custom-input__field');
    var customWrap = block.querySelector('.cvp-custom-input');

    if (exactOption) {
      dropdown.value = exactOption.value;
      if (customInput) {
        customInput.value = '';
        customInput.disabled = true;
        customInput.setCustomValidity('');
      }
      if (customWrap) customWrap.style.display = 'none';
    } else if (customOption && customInput) {
      dropdown.value = customSelectionValue;
      customInput.value = value;
      customInput.disabled = false;
      customInput.setCustomValidity('');
      if (customWrap) customWrap.style.display = 'block';
    } else {
      return false;
    }

    block.classList.remove('is-attention');
    var errorElement = block.querySelector('.cvp-error');
    if (errorElement) errorElement.style.display = 'none';
    return true;
  }

  function closeInstanceGuide(restoreFocus) {
    var modal = Array.from(document.querySelectorAll('.cvp-modal[data-cvp-owner]')).find(function (candidate) {
      return candidate.dataset.cvpOwner === ownerId && candidate.classList.contains('is-open');
    });
    if (modal) closeGuideModal(modal, restoreFocus !== false);
  }

  function applyLengthRecommendation(result) {
    result = result || {};
    var block = wrapper.querySelector('.cvp-option[data-option-role="length"]');
    var dropdown = block && block.querySelector('.cvp-dropdown');
    var customInput = block && block.querySelector('.cvp-custom-input__field');
    if (['standard', 'custom'].indexOf(result.status) === -1) {
      return { ok: false, reason: 'invalid_recommendation' };
    }
    if (!block || !dropdown || !result.longMm || !result.shortMm) {
      return { ok: false, reason: 'size_unavailable' };
    }

    var requestedValue = result.longMm + '/' + result.shortMm + ' mm';

    if (result.status === 'standard') {
      var exactOption = Array.from(dropdown.options).find(function (option) {
        return option.value && option.value !== customSelectionValue && !option.disabled &&
          measurementOptionMatches(option, requestedValue);
      });
      if (!exactOption) return { ok: false, reason: 'size_unavailable' };

      dropdown.value = exactOption.value;
      dropdown.dispatchEvent(new Event('change', { bubbles: true }));
      return { ok: true, control: dropdown, value: exactOption.value };
    }

    var customOption = Array.from(dropdown.options).find(function (option) {
      return option.value === customSelectionValue;
    });
    if (!customOption || customOption.disabled || !customInput) return { ok: false, reason: 'custom_length_unavailable' };

    dropdown.value = customSelectionValue;
    customInput.value = requestedValue;
    dropdown.dispatchEvent(new Event('change', { bubbles: true }));
    customInput.dispatchEvent(new Event('input', { bubbles: true }));
    customInput.dispatchEvent(new Event('change', { bubbles: true }));
    return { ok: true, control: customInput, value: requestedValue };
  }

  function prepareCustomisation(detail) {
    detail = detail || {};
    var widthReady = setCustomisationMeasurement('lug', detail.width);
    var lengthReady = setCustomisationMeasurement('length', detail.length);
    if (!widthReady || !lengthReady) return false;

    syncSelectionsFromDom();
    syncFormBoundProperties();
    applyVariant({ rerender: false });
    return validateSelections(false);
  }

  function refreshSelectedVariant() {
    if (!selectedVariant || destroyed || renderPending) return Promise.resolve(false);
    return rerenderForVariant(selectedVariant, selectedVariant).then(function () { return true; });
  }

  function getFormVariantInput() {
    var productForm = getProductForm();
    return productForm ? productForm.querySelector('input[name="id"]') : null;
  }

  var addToCartLabel = wrapper.dataset.addToCartLabel;
  var soldOutLabel = wrapper.dataset.soldOutLabel;
  var unavailableLabel = wrapper.dataset.unavailableLabel;

  function getMissingOptionBlocks() {
    syncSelectionsFromDom();

    return optionBlocks.filter(function (block) {
      if (!Object.prototype.hasOwnProperty.call(selections, block.dataset.optionPosition)) return true;
      var dropdown = block.querySelector('.cvp-dropdown');
      var customInput = block.querySelector('.cvp-custom-input__field');
      return Boolean(dropdown && dropdown.value === customSelectionValue && customMeasurementError(block, customInput));
    });
  }

  function getOptionGuidanceLabel(block) {
    if (block.dataset.optionRole === 'lug') return 'Lug Width';
    if (block.dataset.optionRole === 'length') return 'Size';
    if (block.dataset.optionRole === 'buckle') return 'Buckle';
    return block.dataset.optionName || 'Options';
  }

  function joinGuidanceLabels(blocks) {
    var labels = blocks.map(getOptionGuidanceLabel);
    if (labels.length <= 1) return labels[0] || 'Options';
    if (labels.length === 2) return labels[0] + ' & ' + labels[1];
    return labels.slice(0, -1).join(', ') + ' & ' + labels[labels.length - 1];
  }

  function isPaymentButton(control) {
    return control.classList.contains('shopify-payment-button__button');
  }

  function lockPaymentButton(control) {
    var existingLock = control._cernirCvpPaymentLock;
    if (!existingLock) {
      control._cernirCvpPaymentLock = {
        owner: paymentLockOwner,
        wasDisabled: control.disabled,
        ariaDisabled: control.getAttribute('aria-disabled')
      };
    } else if (existingLock.owner !== paymentLockOwner) {
      control._cernirCvpPaymentLock = {
        owner: paymentLockOwner,
        wasDisabled: existingLock.wasDisabled,
        ariaDisabled: existingLock.ariaDisabled
      };
    }
    control.disabled = true;
    control.setAttribute('aria-disabled', 'true');
  }

  function releasePaymentButtonLock(control) {
    var existingLock = control._cernirCvpPaymentLock;
    if (!existingLock || existingLock.owner !== paymentLockOwner) return;
    control.disabled = existingLock.wasDisabled;
    if (existingLock.ariaDisabled === null) control.removeAttribute('aria-disabled');
    else control.setAttribute('aria-disabled', existingLock.ariaDisabled);
    delete control._cernirCvpPaymentLock;
  }

  function getSubmitControls() {
    var productForm = getProductForm();
    if (!productForm) return [];

    var controls = Array.from(productForm.elements).filter(function (control) {
      return control.type === 'submit';
    });
    productForm.querySelectorAll('.shopify-payment-button__button').forEach(function (control) {
      if (controls.indexOf(control) === -1) controls.push(control);
    });
    return controls;
  }

  function applyPurchaseStateToControl(control) {
    var disabled = purchaseState === 'loading' || purchaseState === 'sold-out' ||
      purchaseState === 'unavailable' || isPaymentButton(control) && purchaseState !== 'ready';

    if (isPaymentButton(control)) {
      if (disabled) lockPaymentButton(control);
      else releasePaymentButtonLock(control);
    } else {
      control.disabled = disabled;
      if (control.disabled) control.setAttribute('aria-disabled', 'true');
      else control.removeAttribute('aria-disabled');
    }
    control.dataset.cvpState = purchaseState;
  }

  function syncPurchaseControls() {
    getSubmitControls().forEach(applyPurchaseStateToControl);
  }

  function setSubmitState(isValid, missingBlocks, variant) {
    var label;
    var state;

    if (missingBlocks.length) {
      label = 'Select ' + joinGuidanceLabels(missingBlocks);
      state = 'incomplete';
    } else if (isValid) {
      label = addToCartLabel;
      state = 'ready';
    } else {
      label = variant && variant.available === false ? soldOutLabel : unavailableLabel;
      state = variant && variant.available === false ? 'sold-out' : 'unavailable';
    }

    purchaseState = state;
    getSubmitControls().forEach(function (control) {
      applyPurchaseStateToControl(control);

      if (isPaymentButton(control)) return;
      if (control.tagName === 'INPUT') {
        control.value = label;
      } else {
        control.textContent = label;
      }
    });
  }

  function setSubmitPendingState() {
    purchaseState = 'loading';
    syncPurchaseControls();
  }

  function focusFirstMissing(missingBlocks) {
    var block = missingBlocks[0];
    if (!block) return;

    block.classList.add('is-attention');
    block.scrollIntoView({ behavior: 'smooth', block: 'center' });

    var customInput = block.querySelector('.cvp-custom-input__field:not([disabled])');
    var target = customInput || block.querySelector('.cvp-dropdown, .cernir-buckle__row:not([aria-disabled="true"]), .cvp-pill:not([aria-disabled="true"]), .cvp-swatch:not([aria-disabled="true"])');
    if (target) window.setTimeout(function () { target.focus({ preventScroll: true }); }, 350);
  }

  function syncFormBoundProperties() {
    var hasCustomSelection = Array.from(wrapper.querySelectorAll('.cvp-dropdown')).some(function (dropdown) {
      var customInput = dropdown.closest('.cvp-option')?.querySelector('.cvp-custom-input__field');
      return dropdown.value === customSelectionValue && customInput && customInput.value.trim();
    });

    wrapper.querySelectorAll('.cvp-option--dropdown').forEach(function (block) {
      var dropdown = block.querySelector('.cvp-dropdown');
      var propertyInput = block.querySelector('.cvp-option-property');
      var displayPropertyInput = block.querySelector('.cvp-display-option-property');
      var customMarker = block.querySelector('.cvp-custom-marker');
      if (!dropdown || !propertyInput) return;

      var customSelected = dropdown.value === customSelectionValue;
      var includeProperty = hasCustomSelection && dropdown.value && !customSelected;
      propertyInput.disabled = !includeProperty;
      propertyInput.value = includeProperty ? dropdown.value : '';
      if (displayPropertyInput) {
        var customInput = block.querySelector('.cvp-custom-input__field');
        var displayValue = customSelected && customInput ? customInput.value.trim() : dropdown.value;
        displayPropertyInput.disabled = !displayValue;
        displayPropertyInput.value = displayValue || '';
      }
      if (customMarker) customMarker.disabled = !customSelected;
    });
  }

  function captureOptionState() {
    return optionBlocks.map(function (block) {
      var dropdown = block.querySelector('.cvp-dropdown');
      var customInput = block.querySelector('.cvp-custom-input__field');
      var customWrap = block.querySelector('.cvp-custom-input');
      var labelValue = block.querySelector('.cvp-label__value');

      return {
        position: block.dataset.optionPosition,
        dropdownValue: dropdown ? dropdown.value : null,
        selectedButtons: Array.from(block.querySelectorAll('.cvp-pill, .cvp-swatch, .cernir-buckle__row')).map(function (button) {
          return button.classList.contains('is-selected');
        }),
        customValue: customInput ? customInput.value : null,
        customDisabled: customInput ? customInput.disabled : null,
        customVisible: customWrap ? customWrap.style.display : null,
        labelValue: labelValue ? labelValue.textContent : null
      };
    });
  }

  function restoreOptionState(optionState) {
    if (!optionState) return;

    optionState.forEach(function (savedBlock) {
      var block = wrapper.querySelector('.cvp-option[data-option-position="' + savedBlock.position + '"]');
      if (!block) return;

      var dropdown = block.querySelector('.cvp-dropdown');
      var customInput = block.querySelector('.cvp-custom-input__field');
      var customWrap = block.querySelector('.cvp-custom-input');
      var labelValue = block.querySelector('.cvp-label__value');

      if (dropdown && savedBlock.dropdownValue !== null) dropdown.value = savedBlock.dropdownValue;
      block.querySelectorAll('.cvp-pill, .cvp-swatch, .cernir-buckle__row').forEach(function (button, index) {
        button.classList.toggle('is-selected', Boolean(savedBlock.selectedButtons[index]));
      });
      syncPressedState(block);
      if (customInput && savedBlock.customValue !== null) {
        customInput.value = savedBlock.customValue;
        customInput.disabled = savedBlock.customDisabled;
        customInput.setCustomValidity(
          !savedBlock.customDisabled && !savedBlock.customValue.trim() ? 'Please enter a custom value.' : ''
        );
      }
      if (customWrap && savedBlock.customVisible !== null) customWrap.style.display = savedBlock.customVisible;
      if (labelValue && savedBlock.labelValue !== null) labelValue.textContent = savedBlock.labelValue;
    });

    syncSelectionsFromDom();
    syncFormBoundProperties();
  }

  committedControlState = captureOptionState();

  function dispatchVariantChange(productForm, variant, previousVariant) {
    productForm.dispatchEvent(new CustomEvent('variant:change', {
      bubbles: true,
      detail: {
        formId: productForm.id,
        variant: variant,
        previousVariant: previousVariant
      }
    }));
  }

  /* Prestige replaces every liquid block on product:rerender, which closed the description/spec accordions the
     customer had opened. Remember each block's <details> states (scoped to this product's product-rerender, so a
     quick-buy modal never affects the page) and put them back on the new markup. */
  function captureDetailsState(productForm) {
    var scope = productForm.closest('product-rerender');
    if (!scope) return [];
    return Array.from(scope.querySelectorAll('[data-block-type="liquid"][data-block-id]')).map(function (block) {
      return {
        blockId: block.dataset.blockId,
        open: Array.from(block.querySelectorAll('details')).map(function (details) { return details.open; })
      };
    }).filter(function (entry) { return entry.open.length; });
  }

  function restoreDetailsState(productForm, saved) {
    var scope = productForm.closest('product-rerender');
    if (!scope) return;
    saved.forEach(function (entry) {
      var block = Array.from(scope.querySelectorAll('[data-block-type="liquid"][data-block-id]')).find(function (candidate) {
        return candidate.dataset.blockId === entry.blockId;
      });
      var details = block ? Array.from(block.querySelectorAll('details')) : [];
      if (details.length !== entry.open.length) return;
      details.forEach(function (item, index) { item.open = entry.open[index]; });
    });
  }

  function captureFormBoundProperties(productForm) {
    return Array.from(productForm.elements).filter(function (control) {
      return control.name && control.name.indexOf('properties[') === 0;
    }).map(function (control) {
      return {
        id: control.id,
        name: control.name,
        type: control.type,
        value: control.value,
        checked: control.checked,
        disabled: control.disabled,
        customMarker: control.matches('.cvp-custom-marker'),
        optionPosition: control.dataset.optionPosition || null
      };
    });
  }

  function restoreFormBoundProperties(productForm, properties) {
    var activeWrapper = Array.from(document.querySelectorAll('.cvp-wrapper[data-product-form-id]')).find(function (candidate) {
      return candidate.dataset.productFormId === formId;
    }) || wrapper;

    properties.filter(function (property) {
      return property.customMarker && !property.disabled && property.optionPosition;
    }).forEach(function (property) {
      var block = activeWrapper.querySelector('.cvp-option[data-option-position="' + property.optionPosition + '"]');
      var dropdown = block ? block.querySelector('.cvp-dropdown') : null;
      if (dropdown) dropdown.value = customSelectionValue;
    });

    properties.forEach(function (property) {
      Array.from(productForm.elements).filter(function (control) {
        return control.name === property.name ||
          control.dataset.propertyName === property.name ||
          Boolean(property.id && control.id === property.id);
      }).forEach(function (control) {
        if (control.matches('.cvp-custom-input__field')) {
          var optionBlock = control.closest('.cvp-option');
          var customSelected = optionBlock?.querySelector('.cvp-dropdown')?.value === customSelectionValue;
          var customWrap = control.closest('.cvp-custom-input');
          control.disabled = !customSelected;
          control.value = customSelected ? property.value : '';
          control.setCustomValidity(customSelected && !control.value.trim() ? 'Please enter a custom value.' : '');
          if (customWrap) customWrap.style.display = customSelected ? 'block' : 'none';
        } else {
          if (property.type === 'checkbox' || property.type === 'radio') control.checked = property.checked;
          else control.value = property.value;
          control.disabled = property.disabled;
        }
      });
    });
  }

  function setVariantInputs(variant) {
    var formVariantInput = getFormVariantInput();

    if (variantIdSelect) variantIdSelect.value = variant ? String(variant.id) : '';

    if (formVariantInput) {
      var nextValue = variant ? String(variant.id) : '';
      var nextDisabled = !variant || !variant.available;
      var changed = formVariantInput.value !== nextValue || formVariantInput.disabled !== nextDisabled;
      formVariantInput.value = nextValue;
      formVariantInput.disabled = nextDisabled;
      if (changed) formVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function updateVariantUrl(variant) {
    if (wrapper.dataset.updateUrl !== 'true') return;

    try {
      var url = new URL(window.location.href);
      var hasCustomSelection = Array.from(wrapper.querySelectorAll('.cvp-dropdown')).some(function (dropdown) {
        return dropdown.value === customSelectionValue;
      });

      if (hasCustomSelection) url.searchParams.delete('variant');
      else if (variant) url.searchParams.set('variant', variant.id);
      else url.searchParams.delete('variant');
      window.history.replaceState({}, '', url.toString());
    } catch (_) {}
  }

  function showRenderFailure() {
    var firstBlock = wrapper.querySelector('.cvp-option');
    var errorElement = firstBlock ? firstBlock.querySelector('.cvp-error') : null;

    if (firstBlock) firstBlock.classList.add('is-attention');
    if (errorElement) {
      errorElement.textContent = 'Unable to update this selection. Please try again.';
      errorElement.style.display = 'block';
    }

    setSubmitState(false, [], null);
  }

  function isCurrentInstanceRequest(requestId, productForm) {
    return !destroyed && wrapper.isConnected && requestId === renderRequestId &&
      wrapper._cernirCvpInstance && wrapper._cernirCvpInstance.destroy === destroy &&
      getProductForm() === productForm;
  }

  function fragmentContainsRerenderTargets(htmlFragment) {
    var targets = Array.from(document.querySelectorAll('product-rerender[observe-form]')).filter(function (target) {
      return target.getAttribute('observe-form') === formId;
    });

    function containsIdDeep(root, id) {
      if (!root || !root.querySelectorAll) return false;

      var directMatch = Array.from(root.querySelectorAll('[id]')).some(function (element) {
        return element.id === id;
      });
      if (directMatch) return true;

      return Array.from(root.querySelectorAll('template')).some(function (template) {
        return containsIdDeep(template.content, id);
      });
    }

    return targets.length === 0 || targets.every(function (target) {
      return target.id && containsIdDeep(htmlFragment, target.id);
    });
  }

  async function rerenderForVariant(variant, previousVariant) {
    var productForm = getProductForm();
    var productUrl = wrapper.dataset.productUrl;
    if (!productForm || !productUrl) return;

    renderPending = true;
    renderRequestId += 1;
    var requestId = renderRequestId;
    if (renderAbortController) renderAbortController.abort();
    var requestAbortController = new AbortController();
    renderAbortController = requestAbortController;
    var formVariantInput = getFormVariantInput();
    if (formVariantInput) formVariantInput.disabled = true;
    setSubmitPendingState();

    var htmlFragment;

    try {
      var url = new URL(productUrl, window.location.origin);
      url.searchParams.set('variant', variant.id);
      if (wrapper.dataset.context === 'quick_buy') {
        // The quick-buy markup only exists in the ?view=quickbuy view (see sections/main-product.liquid).
        url.searchParams.set('view', 'quickbuy');
      } else if (wrapper.dataset.sectionId) {
        url.searchParams.set('section_id', wrapper.dataset.sectionId);
      }

      var response = await fetch(url.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: requestAbortController.signal
      });
      if (!response.ok) throw new Error('Variant section request failed with status ' + response.status);

      var html = await response.text();
      if (!isCurrentInstanceRequest(requestId, productForm)) return;
      htmlFragment = new DOMParser().parseFromString(html, 'text/html');
      if (!fragmentContainsRerenderTargets(htmlFragment)) {
        throw new Error('Variant section response is missing the expected rerender target.');
      }
    } catch (error) {
      if (error.name === 'AbortError' || !isCurrentInstanceRequest(requestId, productForm)) return;
      renderPending = false;
      selectedVariant = committedVariant;
      restoreOptionState(committedControlState);
      setVariantInputs(committedVariant);
      updateVariantUrl(committedVariant);
      showRenderFailure();
      return;
    }

    if (!isCurrentInstanceRequest(requestId, productForm)) return;

    renderPending = false;
    selectedVariant = variant;
    committedVariant = variant;
    committedControlState = captureOptionState();
    setVariantInputs(variant);
    updateVariantUrl(variant);
    setSubmitState(Boolean(variant.available), [], variant);

    var formProperties = captureFormBoundProperties(productForm);
    var detailsState = captureDetailsState(productForm);
    productForm.dispatchEvent(new CustomEvent('product:rerender', {
      detail: { htmlFragment: htmlFragment, productChange: false }
    }));
    var rerenderedProductForm = getProductForm() || productForm;
    restoreFormBoundProperties(rerenderedProductForm, formProperties);
    restoreDetailsState(rerenderedProductForm, detailsState);
    dispatchVariantChange(rerenderedProductForm, variant, previousVariant);
    try { window.Shopify?.PaymentButton?.init(); } catch (_) {}
    window.setTimeout(function () {
      init(document);
      if (isCurrentInstanceRequest(requestId, productForm)) syncPurchaseControls();
    }, 0);
  }

  /* ── Cập nhật hidden select + đồng bộ UI Prestige khi chọn variant ── */
  function applyVariant(options) {
    options = options || {};
    var variant = findVariant();
    var formVariantInput = getFormVariantInput();

    if (!variant) {
      if (renderPending) {
        renderRequestId += 1;
        if (renderAbortController) renderAbortController.abort();
        renderPending = false;
        selectedVariant = committedVariant;
        updateVariantUrl(committedVariant);
      }
      if (formVariantInput) formVariantInput.disabled = true;
      if (variantIdSelect) variantIdSelect.value = '';
      return null;
    }

    if (renderPending && selectedVariant && selectedVariant.id === variant.id) {
      return variant;
    }

    if (renderPending && committedVariant && committedVariant.id === variant.id) {
      renderRequestId += 1;
      if (renderAbortController) renderAbortController.abort();
      renderPending = false;
      selectedVariant = committedVariant;
      setVariantInputs(committedVariant);
      updateVariantUrl(committedVariant);
      return variant;
    }

    var previousVariant = committedVariant;
    selectedVariant = variant;

    if (options.rerender === false || previousVariant && previousVariant.id === variant.id) {
      committedVariant = variant;
      committedControlState = captureOptionState();
      setVariantInputs(variant);
      updateVariantUrl(variant);
    } else {
      if (variantIdSelect) {
        variantIdSelect.value = String(variant.id);
        variantIdSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      rerenderForVariant(variant, previousVariant);
    }

    return variant;
  }

  /* ── Xử lý click Pill / Swatch ─────────────────────────────── */
  wrapper.addEventListener('click', function (e) {
    var tab = e.target.closest('.cernir-buckle__tab');
    if (tab) {
      activateBuckleType(tab.dataset.buckleTab, true);
      return;
    }

    var btn = e.target.closest('.cvp-pill, .cvp-swatch, .cernir-buckle__row');
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;

    var pos   = btn.dataset.optionPosition;
    var value = btn.dataset.value;
    var block = btn.closest('.cvp-option');
    block.classList.remove('is-attention');

    /* Buckle types keep independent finish selections. */
    var selectionGroup = btn.classList.contains('cernir-buckle__row')
      ? block.querySelectorAll('.cernir-buckle__row[data-buckle-type="' + btn.dataset.buckleType + '"]')
      : block.querySelectorAll('.cvp-pill, .cvp-swatch');
    selectionGroup.forEach(function (b) { b.classList.remove('is-selected'); });
    btn.classList.add('is-selected');
    syncPressedState(block);

    /* Cập nhật label hiển thị giá trị đã chọn */
    var labelVal = block.querySelector('.cvp-label__value');
    if (labelVal) labelVal.textContent = ': ' + value;

    if (btn.dataset.buckleType !== 'butterfly') selections[pos] = value;
    setBuckleError('');
    if (btn.dataset.buckleType !== 'butterfly') applyVariant();
    updateBuckleAvailability();
    validateSelections(false);
  }, { signal: instanceAbortController.signal });

  /* ── Xử lý thay đổi Dropdown ─────────────────────────────────  */
  wrapper.addEventListener('change', function (e) {
    var dd = e.target.closest('.cvp-dropdown');
    if (!dd) return;

    var block       = dd.closest('.cvp-option');
    block.classList.remove('is-attention');
    var customWrap  = block.querySelector('.cvp-custom-input');
    var customInput = block.querySelector('.cvp-custom-input__field');
    var pos         = dd.dataset.optionPosition;

    /* Reset lỗi khi chọn bất kỳ giá trị nào */
    dd.style.borderColor = '';
    var errorEl = block.querySelector('.cvp-error');
    if (errorEl) errorEl.style.display = 'none';

    if (dd.value === customSelectionValue) {
      /* Hiện ô nhập liệu + bật disabled=false để được submit trong form */
      if (customWrap) customWrap.style.display = 'block';
      if (customInput) {
        customInput.disabled = false;
        customInput.setCustomValidity('Please enter a custom value.');
        customInput.focus();
      }

      /* Tìm variant hợp lệ để set variant ID (Prestige cần id hợp lệ) */
      syncSelectionsFromDom();
      applyVariant();
    } else {
      /* Ẩn ô nhập liệu + disabled=true để KHÔNG submit giá trị rỗng */
      if (customWrap) customWrap.style.display = 'none';
      if (customInput) {
        customInput.disabled = true;
        customInput.value = '';
        customInput.setCustomValidity('');
      }
      selections[pos] = dd.value;
      applyVariant();
    }

    syncFormBoundProperties();
    updateBuckleAvailability();
    validateSelections(false);
  }, { signal: instanceAbortController.signal });

  /* ── Validate: kiểm tra tất cả dropdown đã chọn chưa ──────────  */
  function validateSelections(showErrors) {
    syncSelectionsFromDom();
    var missingBlocks = getMissingOptionBlocks();

    optionBlocks.forEach(function (block) {
      var errorEl = block.querySelector('.cvp-error');
      var isMissing = missingBlocks.indexOf(block) !== -1;
      var dropdown = block.querySelector('.cvp-dropdown');
      var customInput = block.querySelector('.cvp-custom-input__field');
      var customMissing = dropdown && dropdown.value === customSelectionValue && customInput && !customInput.value.trim();
      var customError = dropdown && dropdown.value === customSelectionValue && customInput ? customMeasurementError(block, customInput) : '';

      if (customInput) {
        customInput.setCustomValidity(customError);
      }

      if (isMissing && showErrors && block === missingBlocks[0]) {
        block.classList.add('is-attention');
        if (errorEl) {
          errorEl.textContent = customError || (customMissing ? 'Please enter a custom value.' : 'Please select ' + (block.dataset.optionName || 'this option') + '.');
          errorEl.style.display = 'block';
        }
      } else {
        block.classList.remove('is-attention');
        if (errorEl) errorEl.style.display = 'none';
      }
    });

    var variant = missingBlocks.length === 0 ? findVariant() : null;
    var valid = Boolean(variant && variant.available);
    var selectedBuckleRow = getSelectedBuckleRow();
    var butterflyActive = Boolean(selectedBuckleRow && selectedBuckleRow.dataset.buckleType === 'butterfly');
    if (butterflyActive) {
      var widthResult = getBuckleWidthResult();
      var addonReady = selectedBuckleRow.getAttribute('aria-disabled') !== 'true' && Boolean(selectedBuckleRow.dataset.addonVariantId);
      if (!addonReady) {
        valid = false;
        setBuckleError('This Butterfly Clasp finish is unavailable.');
      } else if (widthResult.status === 'invalid') {
        valid = false;
        setBuckleError('Enter a valid Lug–Buckle width pair so the clasp width can be confirmed.');
      } else if (widthResult.status === 'ready') {
        setBuckleError('');
      }
    }
    if (renderPending) {
      var pendingFormVariantInput = getFormVariantInput();
      if (pendingFormVariantInput) pendingFormVariantInput.disabled = true;
      setSubmitPendingState();
      return false;
    }
    if (!valid) {
      var formVariantInput = getFormVariantInput();
      if (formVariantInput) formVariantInput.disabled = true;
      if (variantIdSelect) variantIdSelect.value = '';
    }
    setSubmitState(valid, missingBlocks, variant);
    return valid;
  }

  function getBuckleWidthResult() {
    var lugBlock = wrapper.querySelector('.cvp-option[data-option-role="lug"]');
    var dropdown = lugBlock ? lugBlock.querySelector('.cvp-dropdown') : null;
    if (!dropdown || !dropdown.value) return { status: 'missing', value: '' };

    var rawValue = dropdown.value;
    if (rawValue === customSelectionValue) {
      var customInput = lugBlock.querySelector('.cvp-custom-input__field');
      if (!customInput || !customInput.value.trim()) return { status: 'missing', value: '' };
      rawValue = customInput.value;
    } else {
      var selectedOption = dropdown.options[dropdown.selectedIndex];
      rawValue = selectedOption ? selectedOption.dataset.rawValue || selectedOption.value : rawValue;
    }

    var parts = measurementParts(rawValue).map(Number);
    if (parts.length !== 2 || !Number.isFinite(parts[1]) || parts[1] <= 0) return { status: 'invalid', value: '' };
    return { status: 'ready', value: parts[1] + ' mm' };
  }

  function formProperties(formData) {
    var properties = {};
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && String(value).trim()) properties[match[1]] = String(value);
    });
    return properties;
  }

  function addSelectedDisplayProperties(properties) {
    optionBlocks.forEach(function (block) {
      if (block.dataset.optionRole !== 'lug' && block.dataset.optionRole !== 'length') return;
      var dropdown = block.querySelector('.cvp-dropdown');
      if (!dropdown || !dropdown.value) return;
      var customInput = block.querySelector('.cvp-custom-input__field');
      var selectedOption = dropdown.options[dropdown.selectedIndex];
      var displayValue = dropdown.value === customSelectionValue && customInput
        ? customInput.value.trim()
        : (selectedOption ? selectedOption.dataset.rawValue || selectedOption.value : dropdown.value);
      if (displayValue) {
        properties['_Cernir Display Option ' + block.dataset.optionPosition] = displayValue;
        if (block.dataset.optionRole === 'lug') properties['Lug Width'] = displayValue;
        if (block.dataset.optionRole === 'length') properties.Size = displayValue;
      }
    });
    return properties;
  }

  function variantTitleWithoutOption(variant, optionPosition, displayProperties) {
    var hiddenIndex = Number(optionPosition) - 1;
    var optionValues = Array.isArray(variant.options) ? variant.options.slice() : String(variant.title || '').split(' / ');
    if (!Number.isInteger(hiddenIndex) || hiddenIndex < 0 || hiddenIndex >= optionValues.length) return variant.title || '';
    optionValues = optionValues.map(function (value, index) {
      return displayProperties['_Cernir Display Option ' + (index + 1)] || value;
    });
    optionValues.splice(hiddenIndex, 1);
    return optionValues.join(' / ');
  }

  function variantTitleWithDisplayProperties(variant, displayProperties) {
    var optionValues = Array.isArray(variant.options) ? variant.options.slice() : String(variant.title || '').split(' / ');
    return optionValues.map(function (value, index) {
      return displayProperties['_Cernir Display Option ' + (index + 1)] || value;
    }).join(' / ');
  }

  function prepareCartSelection(productForm) {
    applyVariant();
    if (!validateSelections(true)) {
      focusFirstMissing(getMissingOptionBlocks());
      return { ok: false };
    }

    var variant = findVariant();
    if (!variant) return { ok: false };
    var formData = new FormData(productForm);
    var quantity = Math.max(1, parseInt(formData.get('quantity') || '1', 10) || 1);
    var strapProperties = formProperties(formData);
    addSelectedDisplayProperties(strapProperties);
    var buckleRow = getSelectedBuckleRow();
    var butterflyActive = Boolean(buckleRow && buckleRow.dataset.buckleType === 'butterfly');
    var strapVariantTitle = butterflyActive
      ? variantTitleWithoutOption(variant, buckleRow.dataset.optionPosition, strapProperties)
      : variantTitleWithDisplayProperties(variant, strapProperties);
    if (strapVariantTitle) strapProperties._cernir_variant_display = strapVariantTitle;

    var addons = [];
    if (butterflyActive) {
      var widthResult = getBuckleWidthResult();
      if (widthResult.status !== 'ready') {
        setBuckleError('Enter a valid Lug–Buckle width pair so the clasp width can be confirmed.');
        return { ok: false };
      }
      strapProperties.Buckle = buckleRow.dataset.buckleProperty || buckleRow.dataset.value;
      addons.push({
        id: Number(buckleRow.dataset.addonVariantId),
        type: 'butterfly-clasp',
        properties: {
          Color: buckleRow.dataset.addonColor,
          'Buckle Width': widthResult.value,
          _cernir_for_strap: wrapper.dataset.productTitle + (strapVariantTitle ? ' / ' + strapVariantTitle : '')
        }
      });
    }

    return {
      ok: true,
      quantity: quantity,
      parent: {
        id: Number(variant.id),
        sellingPlan: formData.get('selling_plan'),
        properties: strapProperties
      },
      addons: addons,
      onSuccessDo: formData.get('on_success'),
      afterComplete: function () { validateSelections(false); }
    };
  }

  /* ── Intercept Add to Cart button để validate ──────────────────  */
  function bindProductForm() {
    var productForm = getProductForm();
    if (!productForm || !wrapper.isConnected || destroyed) return;
    if (productForm._cernirCvpInstanceDestroy && productForm._cernirCvpInstanceDestroy !== destroy) {
      productForm._cernirCvpInstanceDestroy();
    }
    productForm._cernirCvpInstanceDestroy = destroy;
    if (productForm._cernirCvpValidationAbortController) {
      productForm._cernirCvpValidationAbortController.abort();
    }
    validationAbortController = new AbortController();
    productForm._cernirCvpValidationAbortController = validationAbortController;
    productForm.dataset.cvpValidationBound = 'true';
    productForm._cernirCartProductProvider = wrapper._cernirCvpInstance;
    productForm.addEventListener('click', function (e) {
      var paymentButton = e.target.closest('.shopify-payment-button__button');
      if (!paymentButton || purchaseState === 'ready') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      validateSelections(true);
      focusFirstMissing(getMissingOptionBlocks());
    }, { capture: true, signal: validationAbortController.signal });
    if (productForm._cernirCvpPurchaseObserver) productForm._cernirCvpPurchaseObserver.disconnect();
    purchaseObserver = new MutationObserver(syncPurchaseControls);
    purchaseObserver.observe(productForm, { childList: true, subtree: true });
    productForm._cernirCvpPurchaseObserver = purchaseObserver;
    syncFormBoundProperties();
    applyVariant({ rerender: false });
    updateBuckleAvailability();
    if (wrapper.dataset.context === 'main_product' && buckleTypePreferences[wrapper.dataset.productId] === 'butterfly') {
      activateBuckleType('butterfly', false);
    }
    validateSelections(false);
  }

  wrapper.addEventListener('input', function (e) {
    if (!e.target.matches('.cvp-custom-input__field')) return;
    e.target.setCustomValidity(customMeasurementError(e.target.closest('.cvp-option'), e.target));
    applyVariant();
    syncFormBoundProperties();
    updateBuckleAvailability();
    validateSelections(false);
  }, { signal: instanceAbortController.signal });

  window.setTimeout(bindProductForm, 0);

  /* ── Áp dụng ngay khi tải trang — bỏ qua nếu chưa chọn đủ ────  */
  /* Không gọi applyVariant() khi tải trang để giữ trạng thái trống */

  /* Custom option properties are associated with the exact product form through
     their form attributes, so Prestige includes them in its native FormData request. */
  }

  function init(scope) {
    eachMatch(scope || document, '.cvp-wrapper[data-product-form-id]', initVariantPicker);
    eachMatch(scope || document, '.cernir-personalization input[maxlength]', syncPersonalizationCount);
  }

  document.addEventListener('click', function (event) {
    var guideButton = event.target.closest('.cvp-guide-button, .cvp-guide-button-link');
    if (guideButton) {
      var modal = document.getElementById(guideButton.dataset.modal);
      if (!modal) return;
      var currentModal = document.querySelector('.cvp-modal.is-open');
      if (currentModal && currentModal !== modal) closeGuideModal(currentModal, false);
      activeGuideTrigger = guideButton;
      guideButton.setAttribute('aria-expanded', 'true');
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');
      lockGuideBackground(modal);
      var focusableElements = getGuideFocusableElements(modal);
      (focusableElements[0] || modal).focus();
      return;
    }

    var modalControl = event.target.closest('.cvp-modal__close, .cvp-modal__overlay');
    if (modalControl) {
      closeGuideModal(modalControl.closest('.cvp-modal'), true);
      return;
    }

    var helpButton = event.target.closest('[data-personalization-help-button]');
    if (helpButton) {
      var help = document.getElementById(helpButton.getAttribute('aria-controls'));
      var willOpen = helpButton.getAttribute('aria-expanded') !== 'true';
      closeAllHelp('[data-personalization-help-button]', helpButton);
      helpButton.setAttribute('aria-expanded', String(willOpen));
      if (help) help.hidden = !willOpen;
      return;
    }

    if (!event.target.closest('[data-personalization-help]')) closeAllHelp('[data-personalization-help-button]', null);
  });

  document.addEventListener('keydown', function (event) {
    var openModal = document.querySelector('.cvp-modal.is-open');
    if (openModal && event.key === 'Tab') {
      var focusableElements = getGuideFocusableElements(openModal);
      if (!focusableElements.length) {
        event.preventDefault();
        openModal.focus();
        return;
      }

      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];
      if (!openModal.contains(document.activeElement)) {
        event.preventDefault();
        (event.shiftKey ? lastFocusable : firstFocusable).focus();
      } else if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      } else if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
      return;
    }

    if (event.key !== 'Escape') return;

    if (openModal) {
      event.preventDefault();
      closeGuideModal(openModal, true);
      return;
    }

    var openHelp = document.querySelector('[data-personalization-help-button][aria-expanded="true"]');
    if (openHelp) {
      event.preventDefault();
      closeHelp(openHelp, true);
    }
  });

  document.addEventListener('focusin', function (event) {
    var openModal = document.querySelector('.cvp-modal.is-open');
    if (!openModal || openModal.contains(event.target)) return;
    var focusableElements = getGuideFocusableElements(openModal);
    (focusableElements[0] || openModal).focus();
  });

  document.addEventListener('change', function (event) {
    syncPersonalizationCount(event.target);
  });
  document.addEventListener('input', function (event) {
    syncPersonalizationCount(event.target);
  });
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var ownerIds = [];
    eachMatch(event.target, '.cvp-wrapper[data-cvp-owner]', function (wrapper) {
      if (wrapper.dataset.cvpOwner) ownerIds.push(wrapper.dataset.cvpOwner);
      if (wrapper._cernirCvpInstance) wrapper._cernirCvpInstance.destroy();
    });

    document.querySelectorAll('.cvp-modal[data-cvp-owner]').forEach(function (modal) {
      if (ownerIds.indexOf(modal.dataset.cvpOwner) === -1) return;
      closeGuideModal(modal, false);
      modal.remove();
    });
  });
  window.addEventListener('pageshow', function () {
    init(document);
  });

  window.CernirProductOptions = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
})();
